import React, {Component} from 'react';
import {Button, Modal} from 'react-bootstrap';

export default class UpgradeToProceedModal extends Component {
    constructor(props) {
        super(props);
        this._onCancelClick = this._onCancelClick.bind(this);
    }

    _onCancelClick() {
        if (this.props.onCancelClick) {
            this.props.onCancelClick();
        }
    }

  render() {
    return(
      <Modal keyboard show={this.props.show} onHide={this._onCancelClick}>
        <Modal.Header>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.body}
        </Modal.Body>
        <Modal.Footer>
            <a href="/upgrade/" target="_blank" rel="noopener noreferrer">
                <Button bsStyle="primary">
                    {this.props.upgradeButton}
                </Button>
            </a>
            <Button
                onClick={this._onCancelClick}
            >
                {this.props.cancelButton}
            </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
